export enum RequestCustomFieldSettingType {
  NONE,
  GENERAL,
  ECI_DIVISION_COMERCIAL
}
